module.exports = __webpack_public_path__ + "img/bottom_right_corner_ribbon.f99356e3.png";